/**
 * Dashboard domains translations: domains, domain (detail features like DynDNS)
 */

export const domains = {
  overview: {
    title: 'Domains',
    subtitle: 'Verwalte deine registrierten Domains',
    loading: 'Domains werden geladen...',
    noDomains: 'Keine Domains vorhanden',
    noDomainsText: 'Du hast noch keine Domains registriert. Registriere eine neue Domain um loszulegen.',
    registerDomain: 'Domain registrieren',
    contacts: 'Kontakte',
    search: 'Domain suchen...',
    sort: 'Sortieren:',
    sortName: 'Name',
    sortExpiry: 'Ablaufdatum',
    sortRegistered: 'Registriert',
    allDomains: 'Alle Domains',
    activeDomains: 'Aktive Domains',
    expiringDomains: 'Bald ablaufende Domains',
    canceledDomains: 'Gekündigte Domains',
    suspendedDomains: 'Pausierte Domains',
    domain: 'Domain',
    domains: 'Domains',
    noResults: 'Keine Domains gefunden für "{query}"',
    noResultsCategory: 'Keine Domains in dieser Kategorie',
    resetFilters: 'Filter zurücksetzen',
    daysRemaining: '{days} Tage',
    externalBadge: 'E-Mail',
    emailHosting: 'E-Mail Hosting',
    dnsSettings: 'DNS-Einstellungen',
    manageEmail: 'E-Mail verwalten',
    orderEmail: 'E-Mail-Hosting bestellen',
    settings: 'Einstellungen',
    manage: 'Verwalten',
    subCustomer: 'Unterkunde',
    filterAll: 'Alle',
    filterOwn: 'Eigene',
    filterSubCustomer: 'Unterkunden',
    switchToManage: 'Wechseln & verwalten',
    statsBreakdown: '{own} eigene + {sub} Unterkunden',
    sortOwner: 'Inhaber',
    stats: {
      total: 'Gesamt',
      active: 'Aktiv',
      expiring: 'Läuft ab',
      canceled: 'Gekündigt',
      suspended: 'Pausiert'
    },
    status: {
      active: 'Aktiv',
      canceled: 'Gekündigt',
      suspended: 'Pausiert',
      deleted: 'Gelöscht',
      tradeOut: 'Wegtransferiert',
      transferPending: 'Transfer läuft',
      expiring: 'Läuft bald ab',
      unknown: 'Unbekannt'
    }
  },
  management: {
    title: 'Domain-Verwaltung',
    errorLoading: 'Fehler beim Laden',
    errorMessage: 'Domain-Details konnten nicht geladen werden. Bitte versuche es später erneut.',
    retry: 'Erneut versuchen',
    suspended: {
      banner: 'Diese Domain ist derzeit gesperrt',
      reason: 'Grund: {reason}',
      since: 'Gesperrt seit: {date}',
      contactSupport: 'Bitte kontaktiere den Support für weitere Informationen.',
      reasons: {
        abuse: 'Missbrauch',
        nis2_violation: 'NIS2-Verstoß',
        legal: 'Rechtliche Gründe',
        manual: 'Manuell gesperrt',
        unknown: 'Nicht angegeben'
      }
    },
    externalDomain: {
      subtitle: 'E-Mail Domain',
      info: 'Diese Domain wird extern verwaltet und bei ITSH für E-Mail Hosting genutzt.',
      manageEmail: 'E-Mail verwalten',
      manageEmailDesc: 'Postfächer, Weiterleitungen und DNS-Einstellungen für diese Domain verwalten.'
    },
    transferPending: {
      title: 'Transfer läuft',
      since: 'Gestartet am {date}.',
      message: 'DNS-Einträge und DynDNS kannst du schon vorbereiten. Nameserver, Kontakte und die übrigen Domain-Einstellungen stehen bereit, sobald der Transfer abgeschlossen ist.'
    }
  },
  contract: {
    title: 'Vertragsdetails',
    subtitle: 'Vertragsinformationen und Laufzeit',
    startDate: 'Vertragsbeginn',
    nextRenewal: 'Nächste Verlängerung',
    expiresOn: 'Läuft ab am',
    canceledOn: 'Gekündigt am',
    cancellationPeriod: 'Kündigungsfrist:',
    contractDuration: 'Vertragslaufzeit:',
    billingPeriod: 'Abrechnungsperiode:',
    days30: '30 Tage',
    month1: '1 Monat',
    months3: '3 Monate',
    months6: '6 Monate',
    months12: '12 Monate',
    inDays: 'in {days} Tagen'
  },
  actions: {
    title: 'Domain Aktionen',
    subtitle: 'Verwaltung und Einstellungen',
    transfer: 'Transfer',
    transferDesc: 'Domain zu einem anderen Anbieter übertragen',
    cancel: 'Kündigen',
    cancelDesc: 'Domain-Vertrag zum nächsten Termin kündigen',
    cancelRevoke: 'Kündigung aufheben',
    cancelRevokeDesc: 'Bestehende Kündigung widerrufen',
    manageEmail: 'E-Mail verwalten',
    manageEmailDesc: 'Postfächer, Weiterleitungen und DNS für diese Domain',
    orderEmail: 'E-Mail-Hosting bestellen',
    orderEmailDesc: 'Postfächer für diese Domain einrichten',
    linkPackage: 'Webpaket',
    linkPackageDesc: 'Domain mit einem Webpaket verknüpfen',
    comingSoon: 'Bald',
    transferLock: 'Transfer-Sperre',
    transferLocked: 'Domain ist gesperrt',
    transferUnlocked: 'Transfers erlaubt',
    transferLockHintLocked: 'Deaktiviere die Sperre, um die Domain zu einem anderen Anbieter zu transferieren.',
    transferLockHintUnlocked: 'Aktiviere die Sperre, um ungewollte Transfers zu verhindern.',
    transferLockUpdated: 'Transfer-Sperre aktualisiert',
    transferLockEnabled: 'Die Domain ist jetzt gegen Transfers gesperrt.',
    transferLockDisabled: 'Die Transfer-Sperre wurde aufgehoben. Die Domain kann jetzt transferiert werden.',
    whoisProtection: 'WHOIS-Schutz',
    whoisProtectionEnabled: 'WHOIS-Daten sind geschützt',
    whoisProtectionDisabled: 'WHOIS-Daten sind öffentlich',
    whoisProtectionUpdated: 'WHOIS-Schutz aktualisiert',
    whoisProtectionHintEnabled: 'Deine persönlichen Daten sind in der öffentlichen WHOIS-Abfrage nicht sichtbar. Die Abrechnung erfolgt jährlich bei der nächsten Verlängerung.',
    whoisProtectionHintDisabled: 'Deine persönlichen Daten sind in der öffentlichen WHOIS-Abfrage sichtbar.',
    trusteeService: 'Treuhänder-Service',
    trusteeServiceEnabled: 'Treuhänder-Service ist aktiv',
    trusteeServiceDisabled: 'Treuhänder-Service ist inaktiv',
    trusteeServiceUpdated: 'Treuhänder-Service aktualisiert',
    trusteeServiceHintEnabled: 'Ein lokaler Treuhänder übernimmt die Admin-Kontaktfunktion für diese Domain. Die Abrechnung erfolgt jährlich bei der nächsten Verlängerung.',
    trusteeServiceHintDisabled: 'Kein Treuhänder aktiv. Einige TLDs erfordern einen Admin-Kontakt mit Wohnsitz im Zielland.',
    addonPricePerYear: '{price}/Jahr inkl. MwSt.',
    addonPricePerYearNet: '{price}/Jahr, ohne MwSt.',
    addonOwnerOnly: 'Einschalten kann nur der Inhaber des Accounts, weil es kostenpflichtig ist.',
    addonUpdateFailed: '{addon} konnte bei der Registry nicht geändert werden. Bitte versuche es später erneut.',
    addonNotSupported: '{addon} ist für .{tld}-Domains nicht verfügbar.',
    addonConfirmTitle: 'Kostenpflichtig hinzubuchen?',
    addonConfirmText:
      '{addon} wird für {price} pro Jahr (inkl. MwSt.) zu deinem Vertrag hinzugefügt. Die Abrechnung erfolgt bei der nächsten Verlängerung.',
    addonConfirmTextNet:
      '{addon} wird für {price} pro Jahr (ohne MwSt.) zu deinem Vertrag hinzugefügt. Die Abrechnung erfolgt bei der nächsten Verlängerung.',
    addonConfirmTextNoPrice:
      '{addon} wird kostenpflichtig zu deinem Vertrag hinzugefügt. Die Abrechnung erfolgt bei der nächsten Verlängerung.',
    addonConfirmAction: 'Zahlungspflichtig hinzubuchen'
  },
  transfer: {
    title: 'Domain Transfer',
    authCodeTitle: 'AuthCode',
    subtitle: 'Domain zu einem anderen Anbieter übertragen',
    authCodeSubtitle: 'Verwende diesen Code beim neuen Anbieter',
    warning: 'Achtung:',
    warningText: 'Nach dem Transfer wird die Domain nicht mehr über dieses Portal verwaltet.',
    step1: 'AuthCode hier anfordern',
    step2: 'Domain beim neuen Anbieter einrichten',
    step3: 'AuthCode dort eingeben',
    validUntil: 'Gültig bis',
    infoText: 'Kopiere diesen Code und gib ihn beim neuen Anbieter ein, um den Transfer zu starten.',
    close: 'Schließen',
    cancel: 'Abbrechen',
    requestAuthCode: 'AuthCode anfordern',
    loading: 'Wird geladen...',
    copied: 'Kopiert',
    copiedMessage: 'AuthCode wurde in die Zwischenablage kopiert'
  },
  cancel: {
    title: 'Domain kündigen',
    confirmTitle: 'Kündigung bestätigen',
    question: 'Wann soll die Kündigung wirksam werden?',
    endOfPeriod: 'Zum Ende der Registrierungsperiode',
    endOfPeriodDesc: 'Empfohlen. Die Domain bleibt bis dahin bestehen und kann bis zum Ende der Periode jederzeit per AuthCode zu einem anderen Anbieter transferiert werden.',
    customDate: 'Eigenes Datum',
    earlyForfeitWarning: 'Bei einem Datum vor dem Ende der Registrierungsperiode verfällt die bereits an die Registrierungsstelle gezahlte Gebühr. Eine Erstattung ist nicht möglich, da wir die Periode bei der Registrierungsstelle unwiderruflich erworben haben.',
    warning: 'Achtung!',
    warningText: 'Die Domain wird zum genannten Datum gelöscht und steht danach wieder zur Registrierung frei.',
    revocableNote: 'Bis dahin kannst du die Kündigung jederzeit unter "Kündigung zurücknehmen" widerrufen.',
    domainLabel: 'Domain',
    cancellationDate: 'Kündigungsdatum',
    confirmText: 'Möchtest du {domain} wirklich {date} kündigen?',
    toDate: 'zum {date}',
    back: 'Zurück',
    cancel: 'Abbrechen',
    continue: 'Weiter',
    confirmCancel: 'Kündigen',
    success: 'Kündigung erfolgreich',
    successMessage: '{domain} wurde gekündigt'
  },
  cancelRevoke: {
    title: 'Kündigung zurücknehmen',
    subtitle: 'Domain-Kündigung widerrufen',
    question: 'Möchtest du die Kündigung dieser Domain wirklich zurücknehmen?',
    info: 'Nach dem Widerruf wird die Domain wie gewohnt weiter verlängert und abgerechnet.',
    cancel: 'Abbrechen',
    confirm: 'Kündigung zurücknehmen',
    processing: 'Wird verarbeitet...',
    success: 'Erfolg',
    successMessage: 'Deine Kündigung wurde erfolgreich zurück genommen!',
    error: 'Fehler',
    checkingPrice: 'Preis wird geprüft...',
    redemptionQuestion: 'Diese Domain ist bereits abgelaufen. Sie kann nur noch kostenpflichtig bei der Registry zurückgeholt werden. Möchtest du das tun?',
    redemptionFee: 'Wiederherstellungsgebühr',
    redemptionInfo: 'Der Betrag wird sofort über deine hinterlegte Zahlungsmethode abgerechnet. Schlägt die Wiederherstellung bei der Registry fehl, erstatten wir ihn automatisch zurück.',
    priceUnavailable: 'Für diese Domain lässt sich derzeit kein Preis ermitteln. Bitte kontaktiere den Support.',
    confirmPaid: 'Zahlungspflichtig zurückholen'
  },
  packageLink: {
    title: 'Webpaket verknüpfen',
    subtitle: 'Domain mit einem Hosting-Paket verbinden',
    currentlyLinked: 'Aktuell verknüpft mit:',
    selectPackage: 'Webpaket auswählen',
    selectPlaceholder: 'Webpaket wählen...',
    noPackages: 'Keine Webpakete verfügbar',
    info: 'Die Verknüpfung ermöglicht die Nutzung von Subdomains und weiteren Features.',
    unlink: 'Verknüpfung lösen',
    confirmUnlink: 'Wirklich lösen',
    error: 'Verknüpfung fehlgeschlagen',
    notLinkable: 'Mit diesem Paket lässt sich die Domain nicht verknüpfen. Wähle ein laufendes Webpaket deines Kontos.',
    unlinkMailWarning: 'Löst du die Verknüpfung, wird E-Mail für diese Domain innerhalb einer Stunde abgeschaltet, sofern kein E-Mail-Hosting für sie gebucht ist. Postfächer und E-Mails bleiben gespeichert.',
    cancel: 'Abbrechen',
    save: 'Speichern',
    success: 'Erfolg',
    successMessage: 'Webpaket wurde erfolgreich verknüpft!'
  },
  contacts: {
    title: 'Kontakte',
    manage: 'Verwalten',
    loading: 'Wird geladen...',
    owner: 'Inhaber (Owner-C)',
    admin: 'Administrator (Admin-C)',
    clickToAssign: 'Klicken zum Zuweisen',
    notSupported: 'Von dieser Registry nicht unterstützt',
    selectContact: 'Kontakt auswählen',
    contactUpdated: 'Kontakt aktualisiert',
    ownerChanged: 'Inhaber wurde geändert.',
    adminChanged: 'Administrator wurde geändert.',
    registrantTradeRequired: 'Der Inhaberwechsel für diese Domain ist mit Kosten verbunden. Bitte kontaktiere den Support.',
    verification: {
      verified: 'Verifiziert',
      unverified: 'Nicht verifiziert',
      emailVerified: 'E-Mail verifiziert',
      emailUnverified: 'E-Mail nicht verifiziert',
      emailRevalidationDue: 'Jährliche Bestätigung der E-Mail fällig',
      phoneVerified: 'Telefon verifiziert',
      phoneUnverified: 'Telefon nicht verifiziert',
      email: {
        verify: 'E-Mail verifizieren',
        requestTitle: 'E-Mail verifizieren',
        requestDescription: 'Wir senden einen Bestätigungscode an {email}. Klicke auf "Code senden" um fortzufahren.',
        title: 'E-Mail-Adresse bestätigen',
        description: 'Wir haben einen Bestätigungscode an {email} gesendet.',
        revalidationDescription: 'Gib den Code aus unserer E-Mail zur jährlichen Bestätigung ein, die an {email} gegangen ist. Ist er abgelaufen, fordere einen neuen an.',
        success: 'E-Mail erfolgreich verifiziert',
        autoVerified: 'E-Mail wurde automatisch verifiziert',
        alreadyVerified: 'Diese E-Mail-Adresse war schon verifiziert'
      },
      phone: {
        verify: 'Telefon verifizieren',
        requestTitle: 'Telefon verifizieren',
        requestDescription: 'Wir senden einen Bestätigungscode per SMS an {phone}. Klicke auf "Code senden" um fortzufahren.',
        title: 'Telefonnummer bestätigen',
        description: 'Wir haben einen Bestätigungscode per SMS an {phone} gesendet.',
        success: 'Telefonnummer erfolgreich verifiziert',
        alreadyVerified: 'Diese Telefonnummer war schon verifiziert',
        wrongNumber: 'Falsche Nummer? Kontakt bearbeiten',
        wrongNumberAccount: 'Falsche Nummer? In Kontoeinstellungen ändern'
      },
      otpPlaceholder: 'Bestätigungscode eingeben',
      sendCode: 'Code senden',
      haveCode: 'Ich habe bereits einen Code',
      resendCode: 'Neuen Code senden',
      confirm: 'Bestätigen',
      cancel: 'Abbrechen',
      errors: {
        invalidOtp: 'Ungültiger Bestätigungscode. Nach fünf falschen Codes fordere einen neuen an.',
        expired: 'Code abgelaufen. Bitte fordere einen neuen an.',
        badRequest: 'Ungültige Anfrage',
        handleNotFound: 'Kontakt nicht gefunden',
        serviceUnavailable: 'Der Verifizierungsdienst ist derzeit nicht verfügbar',
        tooManyRequests: 'Zu viele Codes für diesen Kontakt angefordert. Bitte versuche es in einer Stunde erneut.',
        phoneNotMobile: 'Codes per SMS gehen nur an Mobilnummern. Eine Nummer außerhalb von EWR, Schweiz und Großbritannien muss aus deinem eigenen Land sein.',
        smsUnavailable: 'Die Bestätigung per SMS ist gerade nicht verfügbar. Bitte versuche es morgen erneut.',
        tooManyFailures: 'Zu viele falsche Codes für diesen Kontakt. Bitte versuche es morgen erneut.',
        smsDailyLimit: 'Dein Konto hat die Bestätigungs-SMS für heute aufgebraucht. Bitte versuche es morgen erneut.',
        contactChanged: 'Dieser Kontakt hat sich während der Bestätigung geändert, oder deine Kontodaten werden noch übernommen. Lade die Seite neu oder speichere deine Kontodaten erneut und versuche es dann noch einmal.',
        generic: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.'
      },
      whyRequired: 'Gemäß der NIS2-Verordnung müssen Kontaktdaten für Domains verifiziert werden, um die Erreichbarkeit des Domaininhabers sicherzustellen.'
    },
    nis2Warning: {
      title: 'NIS2 Hinweis',
      message: 'Organisationsdaten werden gemäß NIS2-Verordnung öffentlich im WHOIS (RDDS) sichtbar sein.',
      emailTip: "Tipp: Verwende funktionale E-Mail-Adressen (info{'@'}, admin{'@'}, domain{'@'}) statt persönlicher E-Mails für Organisationskontakte."
    },
    deadline: {
      warning: 'Verifizierung läuft ab',
      critical: 'Verifizierung läuft bald ab',
      expired: 'Verifizierung abgelaufen',
      daysRemaining: '{days} Tage verbleibend',
      expiredMessage: 'Die Verifizierungsfrist ist abgelaufen. Bitte aktualisiere und verifiziere deine Kontaktdaten.'
    }
  },
  handlesOverview: {
    title: 'Kontakte',
    subtitle: 'Verwalte deine Domain-Kontakte (Handles)',
    createContact: 'Kontakt erstellen',
    total: 'Gesamt',
    persons: 'Personen',
    organizations: 'Organisationen',
    accountHandles: 'Account Handles',
    searchPlaceholder: 'Kontakt suchen...',
    loading: 'Kontakte werden geladen...',
    empty: {
      title: 'Keine Kontakte vorhanden',
      description: 'Du hast noch keine Domain-Kontakte erstellt. Erstelle einen neuen Kontakt um ihn für Domain-Registrierungen zu verwenden.'
    },
    allContacts: 'Alle Kontakte',
    contactCount: '{count} Kontakt | {count} Kontakte',
    noResults: {
      search: 'Keine Kontakte gefunden für "{query}"',
      category: 'Keine Kontakte in dieser Kategorie',
      resetFilter: 'Filter zurücksetzen'
    }
  },
  nameservers: {
    title: 'Nameserver',
    subtitle: 'DNS-Auflösung konfigurieren',
    current: 'Aktuelle Nameserver',
    external: 'Extern',
    useInwx: 'ITSH Nameserver verwenden',
    useExternal: 'Externe Nameserver verwenden',
    inwxDescription: 'DNS-Verwaltung über dieses Control Panel',
    externalDescription: 'Eigene externe Nameserver verwenden',
    placeholder: 'ns1.example.com',
    add: 'Nameserver hinzufügen',
    remove: 'Entfernen',
    save: 'Speichern',
    saving: 'Speichern...',
    minRequired: 'Mindestens 2 Nameserver erforderlich',
    invalidHostname: 'Ungültiger Hostname',
    confirmSwitch: 'Nameserver wechseln?',
    confirmSwitchMessage: 'Das Ändern der Nameserver kann bis zu 48 Stunden dauern, bis die Änderungen weltweit propagiert sind. Bei Wechsel zu externen Nameservern werden DNS-Einträge in diesem Panel nicht mehr verwendet.',
    updated: 'Nameserver aktualisiert',
    switchedToInwx: 'Die Domain verwendet jetzt ITSH Nameserver.',
    switchedToExternal: 'Die Domain verwendet jetzt externe Nameserver.',
    updateError: 'Fehler beim Aktualisieren'
  },
  dns: {
    title: 'DNS-Einträge',
    subtitle: 'Verwalte DNS-Einträge für {domain}',
    add: 'Eintrag hinzufügen',
    import: 'Importieren',
    templates: 'Vorlagen',
    bulkActions: 'Mehrfachaktionen',
    loading: 'DNS-Einträge werden geladen...',
    noRecords: 'Keine DNS-Einträge vorhanden',
    noRecordsText: 'Klicke auf "DNS-Eintrag anlegen" um einen neuen Eintrag zu erstellen.',
    noFilterResults: 'Keine Treffer gefunden',
    noFilterResultsText: 'Keine DNS-Einträge entsprechen deinen Filterkriterien.',
    resetFilter: 'Filter zurücksetzen',
    type: 'Typ',
    name: 'Name',
    value: 'Wert',
    ttl: 'TTL',
    priority: 'Priorität',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    protectedRecord: 'Dieser Eintrag wird vom Provider verwaltet',
    selectAll: 'Alle auswählen',
    addRecord: 'DNS-Eintrag hinzufügen',
    editRecord: 'DNS-Eintrag bearbeiten',
    recordType: 'Eintragstyp',
    recordName: 'Name',
    recordValue: 'Wert',
    recordTtl: 'TTL (Sekunden)',
    recordPriority: 'Priorität',
    namePlaceholder: "z.B. www oder {'@'} für Root",
    valuePlaceholder: 'z.B. 192.0.2.1 oder example.com',
    ttlPlaceholder: 'Standard: 3600',
    priorityPlaceholder: 'Nur für MX/SRV',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    recordAdded: 'DNS-Eintrag hinzugefügt',
    recordUpdated: 'DNS-Eintrag aktualisiert',
    deleteTitle: 'DNS-Eintrag löschen',
    deleteQuestion: 'Möchtest du diesen DNS-Eintrag wirklich löschen?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteConfirm: 'Löschen',
    deleting: 'Wird gelöscht...',
    recordDeleted: 'DNS-Eintrag gelöscht',
    conflictDyndnsManaged:
      'Dieser Eintrag wird von DynDNS verwaltet und kann nicht manuell geändert werden.',
    conflictRecordExists:
      'Ein DNS-Eintrag mit diesem Namen, Typ und Inhalt existiert bereits.',
    externalNsWarningTitle: 'Externe Nameserver aktiv',
    externalNsWarningText: 'DNS-Einträge können nicht bearbeitet werden, da externe Nameserver verwendet werden. Verwalte die DNS-Einträge bei deinem externen Nameserver-Anbieter.',
    recordDeletedMessage: 'Der DNS-Eintrag wurde erfolgreich gelöscht.',
    importTitle: 'DNS-Einträge importieren',
    importSubtitle: 'Importiere DNS-Einträge aus einer Zone-Datei',
    importPlaceholder: 'Füge hier deine Zone-Datei ein...',
    importButton: 'Importieren',
    importing: 'Wird importiert...',
    importSuccess: 'DNS-Einträge importiert',
    templatesTitle: 'DNS-Vorlagen',
    templatesSubtitle: 'Wähle eine Vorlage aus',
    templatesApply: 'Anwenden',
    bulkSelectAll: 'Alle auswählen',
    bulkDeselectAll: 'Keine auswählen',
    bulkDelete: 'Ausgewählte löschen',
    bulkChangeTtl: 'TTL ändern',
    bulkSelected: '{count} ausgewählt',
    bulkDeleteConfirm: '{count} DNS-Einträge löschen?',
    bulkTtlLabel: 'TTL für {count} Einträge:',
    bulkClearSelection: 'Auswahl aufheben',
    bulkApply: 'Anwenden',
    bulkDeletedTitle: 'DNS-Einträge gelöscht',
    bulkDeletedSuccess: '{count} Einträge gelöscht.',
    bulkDeletedPartial: '{success} Einträge gelöscht, {fail} fehlgeschlagen.',
    bulkTtlUpdatedTitle: 'TTL aktualisiert',
    bulkTtlUpdatedSuccess: 'TTL für {count} Einträge auf {ttl} gesetzt.',
    bulkTtlUpdatedPartial: '{success} Einträge aktualisiert, {fail} fehlgeschlagen.',
    bulkCreateTitle: 'Mehrere DNS-Einträge erstellen',
    bulkCreateSubtitle: 'Füge mehrere Einträge auf einmal hinzu',
    bulkCreatePlaceholder: 'Ein Eintrag pro Zeile im Format: TYP NAME WERT TTL PRIORITY',
    bulkCreate: 'Erstellen',
    bulkCreating: 'Wird erstellt...',
    bulkCreateSuccess: 'Einträge erstellt',
    bulk: {
      title: 'Mehrere DNS-Einträge anlegen',
      addRow: 'Eintrag hinzufügen',
      createCount: '{count} Einträge erstellen',
      creating: 'Wird erstellt...',
      progress: '{current}/{total} erstellt',
      cancel: 'Abbrechen',
      colType: 'Typ',
      colName: 'Name',
      colContent: 'Inhalt',
      colTtl: 'TTL',
      colPriority: 'Prio',
      nameHint: "Verwende {'@'} als Platzhalter für die Domain",
      contentPlaceholder: 'Inhalt...',
      contentRequired: 'Inhalt ist erforderlich',
      invalidIpv4: 'Ungültige IPv4-Adresse',
      invalidIpv6: 'Ungültige IPv6-Adresse',
      priorityRequired: 'Priorität ist erforderlich',
      completeTitle: 'Erstellung abgeschlossen',
      completeSuccess: '{count} DNS-Einträge erfolgreich erstellt.',
      completePartial: '{success} Einträge erstellt, {failed} fehlgeschlagen.'
    },
    importModal: {
      title: 'Zone-Datei importieren',
      dropText: 'Zone-Datei hierher ziehen',
      dropHint: 'oder klicken zum Auswählen',
      supportedFormats: 'Unterstützte Formate: BIND Zone-Dateien (.zone, .txt)',
      parsingFailed: 'Parsing fehlgeschlagen',
      parsingFailedMessage: 'Die Zone-Datei konnte nicht gelesen werden.',
      noRecords: 'Keine Einträge',
      noRecordsMessage: 'Die Zone-Datei enthält keine gültigen DNS-Einträge.',
      fileError: 'Die Datei konnte nicht gelesen werden.',
      parseWarnings: '{count} Warnungen beim Parsing',
      andMore: '...und {count} weitere',
      recordsToImport: '{count} DNS-Einträge zum Importieren',
      colName: 'Name',
      colType: 'Typ',
      colContent: 'Inhalt',
      colTtl: 'TTL',
      moreRecords: '...und {count} weitere Einträge',
      importedProgress: '{current}/{total} importiert',
      importComplete: 'Import abgeschlossen',
      importCompleteSuccess: '{count} DNS-Einträge erfolgreich importiert.',
      importCompletePartial: '{success} Einträge importiert, {fail} fehlgeschlagen.',
      importButton: '{count} Einträge importieren',
      importing: 'Importiere...'
    },
    // Template modal
    templateModal: {
      modalTitle: 'DNS Templates',
      predefinedSection: 'Vordefinierte Templates',
      recordsCount: '{count} Einträge',
      predefined: 'Vordefiniert',
      recordsPreviewTitle: 'DNS-Einträge in diesem Template:',
      colName: 'Name',
      colType: 'Typ',
      colContent: 'Inhalt',
      colTtl: 'TTL',
      colPriority: 'Priorität',
      emptyContent: '(zu setzen)',
      progressCreated: '{current}/{total} erstellt',
      noteAddedToExisting: 'Die Einträge werden zu deiner bestehenden DNS-Konfiguration hinzugefügt.',
      close: 'Schließen',
      cancel: 'Abbrechen',
      applyButton: 'Template anwenden',
      applyingButton: 'Wird angewendet...',
      appliedTitle: 'Template angewendet',
      appliedSuccessMessage: '{count} DNS-Einträge aus Template erstellt.',
      appliedPartialMessage: '{success} Einträge erstellt, {fail} fehlgeschlagen.',
      // Builtin template names and descriptions
      builtinBasicWebsite: {
        name: 'Basis Website',
        description: 'A und CNAME Einträge für eine einfache Website'
      },
      builtinGoogleWorkspace: {
        name: 'Google Workspace',
        description: 'MX und TXT Einträge für Google Workspace Email'
      },
      builtinMicrosoft365: {
        name: 'Microsoft 365',
        description: 'MX und TXT Einträge für Microsoft 365 Email'
      },
      builtinMailserver: {
        name: 'Eigener Mailserver',
        description: 'MX, SPF und DMARC für eigenen Mailserver'
      },
      builtinSubdomainRedirect: {
        name: 'Subdomain Weiterleitung',
        description: 'CNAME Einträge für gängige Subdomains'
      }
    },
    // TTL presets
    ttlPresets: {
      fiveMinutes: '5 Minuten',
      fifteenMinutes: '15 Minuten',
      thirtyMinutes: '30 Minuten',
      oneHour: '1 Stunde',
      fourHours: '4 Stunden',
      twentyFourHours: '24 Stunden',
      seconds: '{value} Sek.',
      minutes: '{value} Min.',
      hours: '{value} Std.',
      days: '{value} Tage'
    },
    // DNS Record types
    recordTypes: {
      // Common types
      A: { description: 'IPv4-Adresse', hint: 'IPv4-Adresse des Ziels' },
      AAAA: { description: 'IPv6-Adresse', hint: 'IPv6-Adresse des Ziels' },
      CNAME: { description: 'Alias auf Hostnamen', hint: 'Ziel-Hostname (mit Punkt am Ende)' },
      TXT: { description: 'Textinformation', hint: 'Text-Wert (z.B. SPF, DKIM, Verifikation)' },
      ALIAS: { description: 'Alias auf Root', hint: 'Ziel-Domain für Root-Alias' },
      PTR: { description: 'Reverse DNS', hint: 'Hostname für Reverse-Lookup' },
      NS: { description: 'Nameserver', disabledReason: 'Wird vom Nameserver verwaltet' },
      SOA: { description: 'Start of Authority', disabledReason: 'Wird vom Nameserver verwaltet' },
      // Mail types
      MX: { description: 'Mailserver', hint: 'Mail-Server Hostname' },
      RP: { description: 'Responsible Person', hint: 'Verantwortliche Person (mbox txt)' },
      // Security types
      CAA: { description: 'SSL-Berechtigung', hint: 'Flags Tag Value (z.B. 0 issue "ca.com")' },
      TLSA: { description: 'DANE/TLS-Zertifikat', hint: 'Usage Selector MatchingType CertData' },
      SSHFP: { description: 'SSH-Fingerprint', hint: 'Algorithm Type Fingerprint' },
      SMIMEA: { description: 'S/MIME-Zertifikat', hint: 'Usage Selector MatchingType CertData' },
      OPENPGPKEY: { description: 'OpenPGP-Key', hint: 'Base64-kodierter OpenPGP-Schlüssel' },
      CERT: { description: 'Zertifikat', hint: 'Type KeyTag Algorithm Certificate' },
      // Advanced types
      SRV: { description: 'Service-Lokalisierung', hint: 'Ziel-Hostname des Service' },
      URI: { description: 'URI-Verweis', hint: 'URI in Anführungszeichen' },
      HTTPS: { description: 'HTTPS-Service', hint: 'Priority Target Params (SVCB für HTTPS)' },
      SVCB: { description: 'Service Binding', hint: 'Priority Target Params' },
      NAPTR: { description: 'Naming Authority', hint: 'Order Pref Flags Service Regexp Replacement' },
      AFSDB: { description: 'AFS-Datenbank', hint: 'Subtype Hostname' },
      HINFO: { description: 'Host-Info', hint: 'CPU OS (in Anführungszeichen)' },
      IPSECKEY: { description: 'IPsec-Key', hint: 'Precedence GatewayType Algorithm Gateway PublicKey' },
      LOC: { description: 'Geolocation', hint: 'Lat Long Alt (RFC 1876 Format)' },
      URL: { description: 'URL-Redirect', hint: 'Ziel-URL für Weiterleitung' },
      // Categories
      categories: {
        common: 'Allgemein',
        mail: 'E-Mail',
        security: 'Sicherheit',
        advanced: 'Erweitert'
      }
    },
    // DNS Presets (quick add)
    presets: {
      googleWorkspace: {
        name: 'Google Workspace E-Mail',
        description: 'Richtet E-Mail über Google Workspace ein (5 MX-Records)'
      },
      microsoft365: {
        name: 'Microsoft 365 E-Mail',
        description: 'Richtet E-Mail über Microsoft 365 ein'
      },
      spfGoogle: {
        name: 'SPF für Google',
        description: 'SPF-Record für Google Workspace'
      },
      spfMicrosoft: {
        name: 'SPF für Microsoft',
        description: 'SPF-Record für Microsoft 365'
      },
      dmarc: {
        name: 'DMARC-Record',
        description: 'Grundlegender DMARC-Schutz'
      },
      webmail: {
        name: 'Webmail aktivieren',
        description: 'CNAME für mail.domain.tld'
      }
    }
  },
  subdomains: {
    title: 'Subdomains',
    subtitle: 'Verwalte Subdomains für {domain}',
    subtitleShort: 'Verwalte deine Subdomains',
    add: 'Subdomain hinzufügen',
    bulkActions: 'Mehrfachaktionen',
    loading: 'Subdomains werden geladen...',
    noSubdomains: 'Keine Subdomains vorhanden',
    noSubdomainsText: 'Füge Subdomains hinzu um loszulegen.',
    name: 'Name',
    target: 'Ziel',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    addSubdomain: 'Subdomain hinzufügen',
    editSubdomain: 'Subdomain bearbeiten',
    subdomainName: 'Subdomain',
    subdomainTarget: 'Ziel',
    namePlaceholder: 'z.B. blog',
    targetPlaceholder: 'z.B. /var/www/blog',
    cancel: 'Abbrechen',
    save: 'Speichern',
    saving: 'Wird gespeichert...',
    subdomainAdded: 'Subdomain hinzugefügt',
    subdomainUpdated: 'Subdomain aktualisiert',
    subdomainDeleted: 'Subdomain wurde gelöscht',
    bulkSelectAll: 'Alle auswählen',
    bulkDeselectAll: 'Keine auswählen',
    bulkDelete: 'Ausgewählte löschen',
    bulkSelected: '{count} ausgewählt'
  },
  transferOut: {
    title: 'Transfer-Out Anfragen',
    subtitle: 'Verwalte ausgehende Domain-Transfers',
    loading: 'Transfer-Anfragen werden geladen...',
    noTransfers: 'Keine Transfer-Anfragen',
    noTransfersText: 'Hier erscheinen Anfragen, wenn jemand versucht, eine deiner Domains zu transferieren.',
    searchPlaceholder: 'Domain suchen...',
    detectedAt: 'Erkannt am',
    gainingRegistrar: 'Neuer Registrar',
    unknownRegistrar: 'Unbekannt',
    expiresAt: 'Läuft ab am',
    stats: {
      total: 'Gesamt',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen'
    },
    status: {
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen',
      completed: 'Abgeschlossen'
    },
    filter: {
      all: 'Alle',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen'
    },
    modal: {
      title: 'Transfer-Out Anfrage',
      warning: 'Achtung',
      warningText: 'Wenn du diesen Transfer NICHT initiiert hast, lehne ihn sofort ab!',
      approve: 'Transfer genehmigen',
      deny: 'Transfer ablehnen',
      close: 'Schließen',
      otpTitle: 'Verifizierung erforderlich',
      totpDescription: 'Gib den Code aus deiner Authenticator-App ein.',
      emailOtpDescription: 'Ein Verifizierungscode wurde an deine E-Mail gesendet.',
      otpPlaceholder: '6-stelliger Code',
      verifyAndApprove: 'Bestätigen & Genehmigen',
      invalidOtp: 'Ungültiger Code. Bitte versuche es erneut.',
      approveSuccess: 'Transfer wurde genehmigt',
      denySuccess: 'Transfer wurde abgelehnt',
      alreadyProcessed: 'Diese Anfrage wurde bereits bearbeitet.',
      notFound: 'Transfer-Anfrage nicht gefunden.',
      approvalLocked: 'Nach fünf falschen Codes kann diese Anfrage nicht mehr genehmigt werden. Zum Fristende kann sie trotzdem automatisch durchgeführt werden, lehne sie also ab, falls du den Transfer nicht veranlasst hast.',
      approveNotAllowed: 'Nur wer das Konto besitzt, kann diesen Transfer genehmigen.',
      denyNotAllowed: 'Deine Rolle in diesem Team erlaubt es nicht, Transfers abzulehnen.',
      newCodeSent: 'Dieser Code ist abgelaufen oder wurde schon verwendet. Wir haben dir einen neuen geschickt.',
      mailUnavailable: 'Wir konnten den Bestätigungscode nicht senden. Bitte versuche es später erneut.',
      tooManyAttempts: 'Zu viele Versuche. Bitte warte ein paar Minuten und versuche es erneut.'
    },
    denyConfirm: {
      title: 'Transfer ablehnen',
      message: 'Bist du sicher, dass du diesen Transfer ablehnen möchtest?',
      confirm: 'Ja, ablehnen',
      cancel: 'Abbrechen'
    }
  },
  internalTransfer: {
    title: 'Interne Transfer-Anfragen',
    subtitle: 'Verwalte interne Domain-Transfer-Anfragen',
    loading: 'Transfer-Anfragen werden geladen...',
    noTransfers: 'Keine Transfer-Anfragen',
    noTransfersText: 'Hier erscheinen Anfragen, wenn jemand eine deiner Domains intern transferieren möchte.',
    searchPlaceholder: 'Domain suchen...',
    requestedAt: 'Angefragt am',
    buyer: 'Käufer',
    unknownBuyer: 'Unbekannt',
    expiresAt: 'Läuft ab am',
    stats: {
      total: 'Gesamt',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen'
    },
    status: {
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen'
    },
    filter: {
      all: 'Alle',
      pending: 'Ausstehend',
      approved: 'Genehmigt',
      denied: 'Abgelehnt',
      expired: 'Abgelaufen'
    },
    modal: {
      title: 'Interne Transfer-Anfrage',
      warning: 'Achtung',
      warningText: 'Ein anderer Nutzer möchte diese Domain übernehmen. Wenn du diesen Transfer NICHT erwartet hast, lehne ihn ab!',
      approve: 'Transfer genehmigen',
      deny: 'Transfer ablehnen',
      close: 'Schließen',
      otpTitle: 'Verifizierung erforderlich',
      totpDescription: 'Gib den Code aus deiner Authenticator-App ein.',
      emailOtpDescription: 'Ein Verifizierungscode wurde an deine E-Mail gesendet.',
      otpPlaceholder: '6-stelliger Code',
      verifyAndApprove: 'Bestätigen & Genehmigen',
      invalidOtp: 'Ungültiger Code. Bitte versuche es erneut.',
      approveSuccess: 'Transfer wurde genehmigt',
      denySuccess: 'Transfer wurde abgelehnt',
      alreadyProcessed: 'Diese Anfrage wurde bereits bearbeitet.',
      notFound: 'Transfer-Anfrage nicht gefunden.',
      approvalLocked: 'Nach fünf falschen Codes kann diese Anfrage nicht mehr genehmigt werden. Die Domain bleibt bei dir.',
      approveNotAllowed: 'Nur wer das Konto besitzt, kann diesen Transfer genehmigen.',
      denyNotAllowed: 'Deine Rolle in diesem Team erlaubt es nicht, Transfers abzulehnen.',
      newCodeSent: 'Dieser Code ist abgelaufen oder wurde schon verwendet. Wir haben dir einen neuen geschickt.',
      mailUnavailable: 'Wir konnten den Bestätigungscode nicht senden. Bitte versuche es später erneut.',
      tooManyAttempts: 'Zu viele Versuche. Bitte warte ein paar Minuten und versuche es erneut.'
    },
    denyConfirm: {
      title: 'Transfer ablehnen',
      message: 'Bist du sicher, dass du diesen Transfer ablehnen möchtest?',
      confirm: 'Ja, ablehnen',
      cancel: 'Abbrechen'
    }
  },
  contactManagement: {
    title: 'Kontakte',
    subtitle: 'Verwalte deine Domain-Kontakte',
    add: 'Kontakt hinzufügen',
    loading: 'Kontakte werden geladen...',
    noContacts: 'Keine Kontakte vorhanden',
    noContactsText: 'Füge Kontakte hinzu um loszulegen.',
    name: 'Name',
    emailColumn: 'E-Mail',
    type: 'Typ',
    actions: 'Aktionen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    person: 'Person',
    organization: 'Organisation',
    addContact: 'Neuen Kontakt erstellen',
    editContact: 'Kontakt bearbeiten',
    addSubtitle: 'Fülle alle erforderlichen Felder aus',
    editSubtitle: 'Ändere die Kontaktdaten',
    contactType: 'Typ',
    selectType: 'Typ auswählen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    organizationName: 'Organisationsname',
    email: 'E-Mail',
    phone: 'Telefon',
    street: 'Straße',
    city: 'Stadt',
    postcode: 'PLZ',
    state: 'Bundesland',
    selectState: 'Bundesland auswählen',
    country: 'Land',
    cancel: 'Abbrechen',
    save: 'Speichern',
    create: 'Erstellen',
    saving: 'Wird gespeichert...',
    contactAdded: 'Kontakt hinzugefügt',
    contactUpdated: 'Kontakt aktualisiert',
    updateError: 'Kontakt konnte nicht aktualisiert werden',
    createError: 'Kontakt konnte nicht erstellt werden',
    limitReached: 'Ein Konto kann höchstens 25 Kontakte haben. Entferne zuerst einen, den du nicht mehr brauchst.',
    defaultContactFollowsAccount: 'Dieser Kontakt folgt deinen Kontodaten. Ändere sie in deinen Kontoeinstellungen.',
    deleteTitle: 'Kontakt löschen?',
    deleteQuestion: 'Bist du sicher, dass du den Kontakt unwiderruflich löschen möchtest?',
    deleteWarning: 'Diese Aktion kann nicht rückgängig gemacht werden. Domains, die diesen Kontakt verwenden, müssen aktualisiert werden.',
    deleteConfirm: 'Löschen',
    deleting: 'Wird gelöscht...',
    contactDeleted: 'Kontakt gelöscht',
    contactDeletedMessage: 'Der Kontakt wurde erfolgreich gelöscht.',
    deleteError: 'Kontakt konnte nicht gelöscht werden',
    deleteNotPossible: 'Löschen nicht möglich',
    linkedToDomain: 'Dieser Kontakt ist mit einer Domain verknüpft und kann nicht gelöscht werden.'
  },
  register: {
    title: 'Domain registrieren',
    subtitle: 'Finde und registriere deine Wunschdomain',
    search: 'Domain suchen',
    searchPlaceholder: 'Deine Wunschdomain eingeben...',
    searching: 'Suche läuft...',
    checkAvailability: 'Verfügbarkeit prüfen',
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
    addToCart: 'In den Warenkorb',
    inCart: 'Im Warenkorb',
    perYear: '/Jahr',
    renewal: 'Verlängerung',
    resultsTitle: 'Suchergebnisse',
    resultsSubtitle: 'Gefundene Domains',
    noResults: 'Keine Domains gefunden',
    noResultsText: 'Versuche es mit einer anderen Suchanfrage.',

    singlePlaceholder: 'Wunschdomain eingeben (z.B. mustermann oder mustermann.de)',
    multiPlaceholder: 'Domains eingeben (eine pro Zeile)\nz.B. mustermann.de\nbeispiel.com:AUTHCODE',
    multiHint: 'Unterstützt: Zeilenumbruch, Komma, Semikolon · Max. {max}',
    pressEnterHint: 'Drücke Enter zur Prüfung',
    multicheck: 'Multicheck',
    uploadFile: 'Datei hochladen',
    allTldsBtn: 'Alle TLDs',
    format: 'Formatieren',
    clear: 'Leeren',
    checkDomain: 'Domain prüfen',
    statsDetected: 'Erkannt: {count}',
    statsInvalid: 'Ungültig: {count}',
    statsDuplicates: 'Duplikate entfernt: {count}',
    statsLimitReached: 'Limit erreicht ({max})',

    noResultsTitle: 'Keine Ergebnisse',
    noResultsDescription: 'Für diese Suche konnten keine Domains gefunden werden.',
    freeOnlyFilter: 'Nur freie Domains',
    tldFilterLabel: 'Endung',
    allTlds: 'Alle Endungen',
    sortLabel: 'Sortieren',
    sortRelevance: 'Relevanz',
    sortPriceAsc: 'Preis aufsteigend',
    sortPriceDesc: 'Preis absteigend',
    sortTld: 'Endung A–Z',
    resultsCount: '{count} Treffer · {selected} ausgewählt',
    selectAll: 'Alle auswählen',
    clearSelection: 'Auswahl löschen',
    registerSelected: '{count} registrieren',
    requestedDomainHeader: 'Deine Wunschdomain',
    creativeSuggestionsHeader: 'Kreative Alternativen',
    popularTldsHeader: 'Beliebte Endungen',
    additionalFreeExtensionsHeader: 'Weitere freie Endungen',
    searchMoreFreeExtensions: 'Mehr freie Endungen suchen',
    allTldsChecked: 'Alle {count} TLDs wurden geprüft',
    pricesIncludeTax: 'alle Preise inkl. MwSt',
    pricesExcludeTax: 'alle Preise zzgl. MwSt',

    statusUsed: 'Belegt',
    statusFree: 'Frei',
    statusInvalid: 'Ungültig',
    statusUnsupported: 'Nicht unterstützt',
    statusProgress: 'Belegt',
    statusError: 'Error',
    statusInternal: 'Belegt',
    statusYours: 'Belegt',
    promo: 'Aktion',
    premium: 'Premium',
    copyDomain: 'Domain kopieren',
    authCodePlaceholder: 'Auth-Code',
    authCodeOptionalHint: 'Kein Auth-Code nötig – Genehmigung per E-Mail an Admin-C (bis zu 15 Tage)',
    registerAction: 'Registrieren',
    transferAction: 'Transferieren',
    alreadyInCart: 'Bereits im Warenkorb',
    alreadyInCartMessage: '{domain} ist bereits im Warenkorb',
    addedToCart: 'Zum Warenkorb hinzugefügt',
    addedToCartMessage: '{domain} wurde dem Warenkorb hinzugefügt',
    goToCart: 'Zum Warenkorb',
    bulkAddedTitle: 'Domains hinzugefügt',
    bulkAddedMessage: '{count} Domain(s) wurden dem Warenkorb hinzugefügt'
  }
} as const

export const delegation = {
  title: 'Delegierter Zugriff',
  subtitle: 'Anderen Benutzern Zugriff auf diese Domain gewähren',
  addDelegate: 'Zugriff gewähren',
  empty: 'Keine delegierten Benutzer',
  emptyDescription: 'Gewähre anderen Benutzern Zugriff, um DNS oder E-Mail für diese Domain zu verwalten.',
  transferPendingHint: 'Solange der Transfer läuft, kannst du Delegierte nur entfernen.',
  columns: {
    email: 'E-Mail',
    permissions: 'Berechtigungen',
    granted: 'Gewährt',
    expires: 'Läuft ab',
    actions: 'Aktionen'
  },
  types: {
    account: 'Konto',
    mailbox: 'Mailbox'
  },
  never: 'Nie',
  edit: 'Bearbeiten',
  delete: 'Entfernen',
  add: {
    title: 'Zugriff gewähren',
    subtitle: 'Einem anderen Benutzer Zugriff gewähren',
    email: 'E-Mail-Adresse',
    emailPlaceholder: "benutzer{'@'}example.com",
    emailHint: 'Der Benutzer muss ein Konto oder eine Mailbox auf diesem System haben',
    presets: 'Voreinstellungen',
    presetsHint: 'Schnellauswahl für häufige Berechtigungskombinationen',
    permissions: 'Berechtigungen',
    permissionsHint: 'Wähle die Berechtigungen, die der Benutzer erhalten soll',
    expiry: 'Ablaufdatum',
    expiryHint: 'Leer lassen für unbegrenzten Zugriff',
    noExpiry: 'Kein Ablaufdatum'
  },
  editModal: {
    title: 'Zugriff bearbeiten',
    subtitle: 'Berechtigungen für {email} anpassen'
  },
  deleteModal: {
    title: 'Zugriff entfernen',
    message: 'Bist du sicher, dass du den Zugriff von {email} auf diese Domain entfernen möchtest?',
    warning: 'Der Benutzer wird sofort den Zugriff auf alle delegierten Funktionen verlieren.',
    confirm: 'Zugriff entfernen'
  },
  presetLabels: {
    mailAdmin: 'Mail-Administrator',
    dnsAdmin: 'DNS-Administrator',
    listManager: 'Mailinglisten-Manager'
  },
  permissionLabels: {
    'dns:read': 'DNS lesen',
    'dns:write': 'DNS verwalten',
    'dyndns:read': 'DynDNS lesen',
    'dyndns:write': 'DynDNS verwalten',
    'mailbox:read': 'Mailboxen lesen',
    'mailbox:write': 'Mailboxen verwalten',
    'mailbox:delete': 'Mailboxen löschen',
    'mailinglist:read': 'Mailinglisten lesen',
    'mailinglist:write': 'Mailinglisten verwalten',
    'alias:read': 'Aliase lesen',
    'alias:write': 'Aliase verwalten',
    'alias:delete': 'Aliase löschen'
  },
  permissionGroups: {
    dns: 'DNS',
    mail: 'E-Mail',
    lists: 'Mailinglisten',
    aliases: 'Aliase'
  },
  notifications: {
    added: 'Zugriff gewährt',
    addedMessage: '{email} hat jetzt Zugriff auf diese Domain.',
    updated: 'Zugriff aktualisiert',
    updatedMessage: 'Die Berechtigungen wurden aktualisiert.',
    deleted: 'Zugriff entfernt',
    deletedMessage: '{email} hat keinen Zugriff mehr auf diese Domain.',
    accountNotFound: 'Kein Konto oder Mailbox mit dieser E-Mail-Adresse gefunden.',
    alreadyDelegate: 'Dieser Benutzer hat bereits Zugriff auf diese Domain.',
    mailboxPermissionsOnly: 'Mailbox-Benutzer können nur E-Mail-Berechtigungen erhalten (Mailboxen und Mailinglisten).'
  }
} as const

export const domain = {
  dyndns: {
    title: 'DynDNS',
    subtitle: 'Dynamische DNS-Updates für wechselnde IP-Adressen',
    empty: 'Keine DynDNS-Tokens vorhanden',
    emptyDescription: 'Erstelle einen Token, um dynamische IP-Updates von deinem Router zu ermöglichen.',
    createToken: 'Token erstellen',
    columns: {
      hostname: 'Hostname',
      type: 'Typ',
      currentIp: 'Aktuelle IP',
      lastUpdate: 'Letztes Update',
      status: 'Status',
      actions: 'Aktionen'
    },
    status: {
      rateLimited: 'Rate-Limit',
      rateLimitedUntil: 'Verfügbar {time}',
      invalidIp: 'Ungültige IP',
      dnsError: 'DNS-Fehler'
    },
    recordTypes: {
      A: 'Nur IPv4',
      AAAA: 'Nur IPv6',
      BOTH: 'IPv4 + IPv6'
    },
    create: {
      title: 'DynDNS-Token erstellen',
      hostname: 'Hostname',
      hostnameHint: "Leer oder {'@'} für Root-Domain",
      recordType: 'Record-Typ',
      description: 'Beschreibung',
      descriptionHint: 'z.B. "Heimrouter"',
      wildcardWarning: 'Wildcard-Einträge (*.domain.tld) überschreiben alle Subdomains ohne explizite DNS-Einträge.'
    },
    created: {
      title: 'Token erstellt',
      titleRotated: 'Token erneuert',
      warning: 'Speichere diesen Token jetzt - er wird nicht erneut angezeigt!',
      warningRotated: 'Der alte Token ist ab sofort ungültig.',
      copyToken: 'Token kopieren',
      copied: 'Kopiert!',
      configTitle: 'Client-Konfiguration',
      clients: {
        fritzbox: 'Fritz!Box',
        ddclient: 'ddclient',
        curl: 'curl',
        openwrt: 'OpenWrt',
        synology: 'Synology'
      },
      copyConfig: 'Konfiguration kopieren',
      copyValue: 'Wert kopieren',
      fields: {
        dyndnsProvider: 'DynDNS-Anbieter',
        ddnsProvider: 'DDNS-Anbieter',
        custom: 'Benutzerdefiniert',
        updateUrl: 'Update-URL',
        serviceUrl: 'Service-URL',
        domainName: 'Domainname',
        hostname: 'Hostname',
        username: 'Benutzername',
        password: 'Kennwort',
        passwordSynology: 'Passwort'
      }
    },
    rotate: {
      tooltip: 'Token erneuern',
      confirm: 'Möchtest du den Token wirklich erneuern? Der alte Token wird sofort ungültig.'
    },
    delete: {
      title: 'Token löschen',
      message: 'Möchtest du diesen DynDNS-Token wirklich löschen?',
      warning: 'Die zugehörigen DNS-Einträge werden ebenfalls entfernt.',
      confirm: 'Token löschen'
    },
    notifications: {
      createSuccess: 'DynDNS-Token erstellt',
      rotateSuccess: 'DynDNS-Token erneuert',
      deleteSuccess: 'DynDNS-Token gelöscht',
      maxTokensReached:
        'Maximale Anzahl an DynDNS-Tokens erreicht ({limit}). Lösche einen nicht mehr benötigten Token, um einen neuen anzulegen.',
      externalNameservers:
        'Diese Domain nutzt externe Nameserver. DynDNS funktioniert nur mit unseren Nameservern.',
      hostnameHasRecords:
        'Für diesen Hostname existieren bereits A/AAAA-Einträge. Lösche diese zuerst.'
    },
    neverUpdated: 'Noch nie',
    noIp: 'Keine IP',
    wildcardTooltip: 'Betrifft alle Subdomains ohne eigene DNS-Einträge'
  }
} as const
